import React from "react";

/** Label + control + one line of help or error. Pass the control as children and give it the same `id`. */
export default function Field({ id, label, hint, error, optional, children, className = "" }) {
  return (
    <div className={`auth-field ${error ? "has-error" : ""} ${className}`}>
      <label htmlFor={id}>
        {label}
        {optional && <span className="auth-optional">optional</span>}
      </label>
      {children}
      {error ? (
        <p className="auth-error" id={`${id}-msg`} role="alert">
          {error}
        </p>
      ) : (
        hint && (
          <p className="auth-hint" id={`${id}-msg`}>
            {hint}
          </p>
        )
      )}
    </div>
  );
}
